<div class="card rounded bg-tertiary">
  <div *ngIf="member$ | async as member">
    <div>
      <label class="text-white mb-0">{{ 'account.details.email' | translate }}</label>
      <div class="d-flex email-container p-2 m-0 mt-1 rounded text-white">
        <span class="icon material-icons" aria-hidden="true">email</span>
        <span class="email ms-2">{{ member.EmailAddress1 }}</span>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
